module.exports = __webpack_public_path__ + "static/media/credit.b14aa05d.png";